import { render, staticRenderFns } from "./ChatWidget.vue?vue&type=template&id=6b2c85a2&scoped=true"
import script from "./ChatWidget.vue?vue&type=script&lang=js"
export * from "./ChatWidget.vue?vue&type=script&lang=js"
import style0 from "./ChatWidget.vue?vue&type=style&index=0&id=6b2c85a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2c85a2",
  null
  
)

export default component.exports